<template>
  <div class="om-scope om-page">
    <router-link class="om-back" :to="homeRoute"><i class="ni ni-bold-left" aria-hidden="true"></i> {{ copy.backToManual }}</router-link>
    <header>
      <p class="om-eyebrow">{{ copy.moduleName }}</p>
      <h1 class="om-history-title">{{ copy.history }}</h1>
      <p class="om-history-lead">{{ copy.historyLead }}</p>
    </header>
    <p v-if="state === states.loading" class="om-status">{{ copy.loading }}</p>
    <div v-else-if="state !== states.ready" class="om-card om-status-card">
      <p>{{ state === states.missing ? copy.notAvailable : copy.loadError }}</p>
      <button v-if="state === states.failed" type="button" class="om-button om-button-ghost" @click="load">{{ copy.retry }}</button>
    </div>
    <ol v-else class="om-timeline">
      <li v-for="(version, index) in versions" :key="version.id" class="om-card om-version" :class="{ 'om-version-current': index === 0 }">
        <div class="om-version-head">
          <h2 class="om-version-label">{{ version.label }}</h2>
          <span v-if="index === 0" class="om-current-pill">{{ copy.historyCurrent }}</span>
          <span class="om-version-date">{{ formatDate(version.published_at) }}</span>
        </div>
        <ul class="om-version-notes">
          <li v-for="line in noteLines(version)" :key="line">{{ line }}</li>
        </ul>
        <manual-pdf-button ghost :manual-key="manualKey" :version-id="version.id" />
      </li>
    </ol>
  </div>
</template>

<script>
import '@/components/OperationsManual/operations-manual.css';
import ManualPdfButton from '@/components/OperationsManual/ManualPdfButton.vue';
import { MANUAL_COPY, MANUAL_ROUTES, changeNoteLines, formatManualDate } from '@/components/OperationsManual/manualCopy';
import manualLoading from './manualLoading';

export default {
  name: 'ManualVersionHistory',
  components: { ManualPdfButton },
  mixins: [manualLoading],
  data() {
    return { copy: MANUAL_COPY, versions: [] };
  },
  computed: {
    homeRoute() {
      return { name: MANUAL_ROUTES.home, params: { manualKey: this.manualKey } };
    },
  },
  methods: {
    async fetchContent() {
      this.versions = await this.$store.dispatch('operationsManual/fetchVersions', this.manualKey);
      return this.versions.length > 0;
    },
    noteLines(version) {
      return changeNoteLines(version.change_notes);
    },
    formatDate(isoDate) {
      return formatManualDate(isoDate);
    },
  },
};
</script>

<style scoped>
.om-back { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 650; color: var(--om-green-dark); }
.om-history-title { font-size: 22px; font-weight: 750; margin: 0; color: var(--om-ink); }
.om-history-lead { color: var(--om-muted); font-size: 13.5px; margin: 4px 0 0; }
.om-timeline { list-style: none; margin: 0; padding: 0; display: grid; gap: 12px; }
.om-version { padding: 16px 18px; }
.om-version-current { border-color: rgba(93, 188, 133, .5); }
.om-version-head { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 12px; margin-bottom: 10px; }
.om-version-label { font-size: 17px; font-weight: 750; margin: 0; color: var(--om-ink); }
.om-current-pill { background: var(--om-green-tint); color: var(--om-green-dark); font-size: 12px; font-weight: 700; padding: 3px 9px; border-radius: 999px; }
.om-version-date { color: var(--om-muted); font-size: 13px; margin-left: auto; }
.om-version-notes { margin: 0 0 14px; padding-left: 20px; line-height: 1.55; color: var(--om-ink); }
@media (max-width: 576px) { .om-version-date { margin-left: 0; width: 100%; } .om-version .om-button { width: 100%; } }
</style>
